"use client"

import { QueryFilters, Sector } from "@cabukaka/types";
import { useData } from "../core/useData";
import { sectorService } from "@cabukaka/services";

export function useSectors(initialFilters?: QueryFilters) {
    const {
        data: sectors,
        loading,
        error,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems,
    } = useData<Sector>({
        ...sectorService,
        ...sectorService.baseService
    }, initialFilters);

    // Fonction pour réorganiser les secteurs
    const updateSectorsOrder = async (orderedSectors: Sector[]) => {
        try {
            // Préparer les données pour l'API
            const orderData = orderedSectors.map((sector, index) => ({
                id: sector.id,
                order: index + 1
            }));

            // Appeler le service
            await sectorService.updateOrder(orderData);
            
            // Rafraîchir les données
            await refresh();
            
        } catch (error) {
            console.error('Erreur updateSectorsOrder:', error);
            throw error;
        }
    };

    return {
        sectors,
        loading,
        error,
        refresh,
        deleteSector: deleteItem,
        updateSector: updateItem,
        deleteManySectors: deleteManyItems,
        updateSectorsOrder,
    };
}